import React from "react";
import { Outlet } from "react-router-dom";
const Protected = ({ userRoles }) => {
    return <Outlet />
}
export default Protected;